'use client';
import { useRef, useEffect } from 'react';
import lottie from 'lottie-web';

const CustomLottie = ({ animData, width = '100%', height = 'auto', isStopped, isPaused = false, display = 'inline-block', loop = true, onComplete }) => {
	const containerRef = useRef(null);
	const animRef = useRef(null);

	useEffect(() => {
		if (!containerRef.current) return;

		if (animRef.current) {
			try {
				animRef.current.destroy();
			} catch {}
			animRef.current = null;
		}

		animRef.current = lottie.loadAnimation({
			container: containerRef.current,
			renderer: 'svg',
			loop,
			autoplay: !(isStopped || isPaused),
			animationData: animData,
		});

		return () => {
			try {
				animRef.current?.destroy();
			} catch {}
			animRef.current = null;
		};
	}, [animData, isStopped, isPaused, loop]);

	useEffect(() => {
		const inst = animRef.current;
		if (!inst || !onComplete) return;
		const handler = () => onComplete();
		inst.addEventListener('complete', handler);
		return () => {
			try {
				inst.removeEventListener('complete', handler);
			} catch {}
		};
	}, [onComplete, animData, loop]);

	useEffect(() => {
		const inst = animRef.current;
		if (!inst) return;

		if (isStopped) inst.stop();
		else if (isPaused) inst.pause();
		else inst.play();
	}, [isStopped, isPaused]);

	return (
		<div
			ref={containerRef}
			style={{ width, height, overflow: 'hidden', display: display }}
		/>
	);
};

export default CustomLottie;
